import React, { Component } from 'react'
import { connect } from 'react-redux'

import classNames from './Stars.css'
import { rateImage, flagImage } from '../redux/image'
import Icon from './Icon'
import FlagImageModal from './modals/FlagImageModal'

class Stars extends Component {
  state = {
    showFlagModal: false
  }
  onClickStar = rating => {
    const { rateImage, image } = this.props
    rateImage(image._id, rating)
  }
  flagImage = options => {
    const { flagImage, image } = this.props
    return flagImage(image._id, options).then(this.closeFlagModal)
  }
  closeFlagModal = () => {
    this.setState({ showFlagModal: false })
    this.props.onCloseFlag && this.props.onCloseFlag()
  }
  render () {
    const { className, rating, image, showFlag, clickable, showInfo, whiteStars, onFlag } = this.props
    const { showFlagModal } = this.state
    const rated = image && image.rated

    const stars = []

    for (let i = 1; i <= 5; i++) {
      const selected = rated === i || (typeof rating === 'object' ? rating[i] : i <= rating)
      const icon = selected ? 'star' : 'star-outline'
      const starClass = selected ? classNames.star : classNames.starOutline
      const hoverClass = clickable && !rated ? ' ' + classNames.clickable : ''
      const clickedClass = rated === i ? ' ' + classNames.clicked : ''
      const onClick = clickable && !rated ? () => this.onClickStar(i) : null

      stars.push(
        <Icon
          key={i}
          icon={icon}
          className={starClass + hoverClass + clickedClass}
          onClick={onClick}
        />
      )
    }

    return (
      <div className={className + (whiteStars ? ' ' + classNames.white : '')}>
        {stars}
        {showFlag &&
          <Icon
            icon='flag'
            className={image.flagged ? classNames.flagged : classNames.flag}
            onClick={() => {
              this.setState({ showFlagModal: true })
              if (onFlag) onFlag()
            }}
          />
        }
        {showInfo &&
          <p className={classNames.info}>
            {image.rated
              ? `You have flagged this image to be rated ${image.rated} stars`
              : 'Select a rating to flag image to be rated'
            }
          </p>
        }
        {showFlagModal &&
          <FlagImageModal
            closeModal={this.closeFlagModal}
            onSubmit={this.flagImage}
          />
        }
      </div>
    )
  }
}

const mapDispatchToProps = {
  rateImage,
  flagImage
}

export default connect(null, mapDispatchToProps)(Stars)



// WEBPACK FOOTER //
// ./src/components/Stars.js